var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyPasswordIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 47.788,
    viewBox: "0 0 44 47.788",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_144",
    "data-name": "Ret\\xE2ngulo 144",
    width: 44,
    height: 47.788,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_622",
    "data-name": "Grupo 622",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_200",
    "data-name": "Caminho 200",
    d: "M36.4,13.525a1.532,1.532,0,0,0,.888.281v0a1.53,1.53,0,0,0,1.41-.926l.651-1.98a3.05,3.05,0,0,1,1.93-1.925l1.889-.614a1.533,1.533,0,0,0-.055-2.91l-1.864-.605a3.055,3.055,0,0,1-1.936-1.936L38.7,1.021a1.536,1.536,0,0,0-2.9.024l-.618,1.9a3.055,3.055,0,0,1-1.884,1.9l-1.884.606a1.536,1.536,0,0,0,.018,2.9l1.863.6a3.073,3.073,0,0,1,1.2.744,2.992,2.992,0,0,1,.253.286,3.05,3.05,0,0,1,.483.91l.614,1.884a1.527,1.527,0,0,0,.56.743m8.143,5.361A1.194,1.194,0,0,1,44.1,18.3l-.348-1.07a1.4,1.4,0,0,0-.333-.541,1.375,1.375,0,0,0-.54-.333l-1.053-.343a1.215,1.215,0,0,1-.606-.451,1.2,1.2,0,0,1-.223-.7,1.215,1.215,0,0,1,.226-.7,1.2,1.2,0,0,1,.593-.443l1.065-.346a1.383,1.383,0,0,0,.849-.87l.344-1.053a1.214,1.214,0,0,1,2.294-.022l.35,1.077a1.38,1.38,0,0,0,.871.867l1.053.343a1.212,1.212,0,0,1,.042,2.3l-1.077.35a1.392,1.392,0,0,0-.537.333,1.373,1.373,0,0,0-.333.54l-.342,1.05a1.22,1.22,0,0,1-.451.605,1.205,1.205,0,0,1-1.409,0",
    transform: "translate(-5.496 0)",
    fill: "#005a9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_201",
    "data-name": "Caminho 201",
    d: "M18.3,19.445a9.828,9.828,0,1,0-5.045,4.222L29.522,39.936,25.468,43.99,30.1,48.624l8.687-8.687Zm-8.466-.414a4.579,4.579,0,1,1,4.579-4.579,4.579,4.579,0,0,1-4.579,4.579",
    transform: "translate(0 -0.837)",
    fill: "#005a9e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyPasswordIcon);
export default __webpack_public_path__ + "static/media/keyPassword-icon.61f4485e6eac032c3aef2c0aa322e586.svg";
export { ForwardRef as ReactComponent };